import { CheckpointOperationType, StepOperationType } from '../enums';

export interface IStepDefinitionOutputDto {
    type: string;
    name: string;
    icon: string;
    normalDuration: string;
    minDuration: string;
    maxDuration: string;
    stateDefinition?: string;
    zoneType?: string;
    finishTripAfter?: string;
    operationType?: StepOperationType;
    isNonOperative?: boolean;
}

export interface ICheckpointDefinitionOutputDto {
    id?: string;
    name: string;
    stateDefinition?: string;
    transitionStateDefinition?: string;
    steps: IStepDefinitionOutputDto[];
    type: string;
    operationType: CheckpointOperationType;
}

export interface ITripDefinitionOutputDto {
    id: string;
    organizationId: string;
    organizations?: string[];
    name: string;
    locale?: string;
    tripLifetime?: string;
    tripStartedLifetime?: string;
    ttlFinishedTrips: string;
    delayedYellow: string;
    delayedRed: string;
    pendingColor: string;
    finishedColor: string;
    minPercentage?: number;
    maxPercentage?: number;
    maxDrivingTime?: number;
    restingTime?: number;
    maxDailyDrivingTime?: number;
    drivingTimeWindow?: [string, string][];
    drivingTimeWindowTolerance?: number;
    metersWithoutOptions?: number;
    finishOnLastCheckpointStep?: boolean;
    forceShowLastCheckpointNext?: boolean;
    startNextTripOnPrevFinish?: boolean;
    checkpointDefinitions: ICheckpointDefinitionOutputDto[];
    finishTripsInProgress?: boolean;
    autoGenerateTripCode?: boolean;
    allowMissingCheckpointTypes?: boolean;
    anticipationTime?: string;
    completeLastCheckpointStepWhenTriggered?: boolean;
    skipEstimation?: boolean;
    finishStateDefinition?: string;
    unfoldHubCheckpointType?: string;
}

export interface IZoneTypes {
    getZoneTypes: {
        types: string[];
    };
}
